export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const CHECK_AUTH = 'checkAuth'
export const UPDATE_USER = 'updateUser'

export const USER_CREATE = 'createUser'
export const USER_DELETE = 'deleteUser'
export const USER_EDIT = 'editUser'
